import React, {MouseEvent, useEffect, useMemo, useState} from "react";
import Grid from "@mui/material/Grid";
import BasicTable from "../../components/tables/BasicTable";
import {ColumnDef} from "@tanstack/react-table";
import {useAppDispatch, useAppSelector} from "../../reducers/hooks";
import {Edit, Trash} from "iconsax-react";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import {Typography} from "@mui/material";
import AlertExampleElementDelete from "../../sections/modals/exampleElementModal/AlertExampleElementDelete";
import ElementModalGeneric from "sections/modals/exampleElementModal/ElementModalGeneric";
import {FormattedMessage, useIntl} from "react-intl";
import {openSnackbar, SnackbarState} from "reducers/snackbar/snackbarReducer";
import UserAdminElementForm from "../../sections/forms/User/UserAdminElementForm";
import {deleteElement, getAllElementByTenant, UserAdminElement} from "../../reducers/User/Admin/UserReducerAdmin";

export default function UserAdmin() {
    const dispatch = useAppDispatch();
    const intl = useIntl();
    const [open, setOpen] = useState<boolean>(false);
    const {elements} = useAppSelector(state => state.userAdminElement)
    const [selectedElement, setSelectedElement] = useState<UserAdminElement | null>(null);
    const [selectedDeleteElement, setSelectedDeleteElement] = useState<any>();
    const [deleteAlertOpen, setDeleteAlertOpen] = useState<boolean>(false);

    // Stati di ricerca per ogni colonna
    /*
        const [searchTerms] = useState({
            username: "",
            email: "",
            tenantId: "",
            enabled:"",
            roles: ""
        });
    */

    const columns = useMemo<ColumnDef<UserAdminElement>[]>(() => [
        {
            header: intl.formatMessage({id: "Username"}),
            accessorKey: 'username',
            enableColumnFilter: false
        },
        {
            header: intl.formatMessage({id: "email"}),
            accessorKey: 'email',
            enableColumnFilter: false
        },
        /* {
             header: intl.formatMessage({ id: "businessName" }),
             accessorKey: 'tenantId.target.businessName',
         },*/
        {
            header: intl.formatMessage({id: "enabled"}),
            accessorKey: 'enabled',
            enableColumnFilter: false,
            disableSortBy: true,
            cell: ({row}) => {
                return (
                    <Stack direction="row" alignItems="center" justifyContent="center" spacing={0}>
                        <Typography>{row.original.enabled ? "Attivo" : "Disattivo"}</Typography>
                    </Stack>
                );
            }
        },
        {
            header: intl.formatMessage({id: "roles"}),
            accessorKey: 'roles',
            enableColumnFilter: false
        },
        {
            header: () => <FormattedMessage id="Actions" defaultMessage="Actions"/>,
            accessorKey: 'Actions',
            enableColumnFilter: false,
            meta: {
                className: 'cell-right',
            },
            disableSortBy: true,
            cell: ({row}) => {
                if (row.original.email !== "argoAdmin@test.com") {
                    return (
                        <Stack direction="row" alignItems="center" justifyContent="center" spacing={0}>
                            <Tooltip title={<FormattedMessage id="edit" defaultMessage="edit"/>}>
                                <IconButton
                                    color="primary"
                                    onClick={(e: MouseEvent<HTMLButtonElement>) => {
                                        e.stopPropagation();
                                        setSelectedElement(row.original)
                                        setOpen(true)
                                    }}
                                >
                                    <Edit/>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={<FormattedMessage id="Delete" defaultMessage="Delete"/>}>
                                <IconButton
                                    color="error"
                                    onClick={(e: MouseEvent<HTMLButtonElement>) => {
                                        e.stopPropagation();
                                        setSelectedDeleteElement(row.original)
                                        setDeleteAlertOpen(true)
                                    }}
                                >
                                    <Trash/>
                                </IconButton>
                            </Tooltip>
                        </Stack>
                    );
                }
            },
        }
    ], [intl]);


    useEffect(() => {
        dispatch(getAllElementByTenant())
    }, []);

    const handleModalOpen = (isOpen: boolean) => {
        setOpen(isOpen);
        if (!isOpen) setSelectedElement(null);
    };

    const onDeleteSuccess = () => {
        //effettuare la dispatch della getAll e della visualizzazione popup
        dispatch(getAllElementByTenant())

        openSnackbar(
            {
                open: true,
                message: 'Element deleted successfully',
                variant: 'alert',
                alert: {
                    color: 'success'
                }
            } as SnackbarState
        )
    };

    const handleDelete = (_id: string) => {
        dispatch(deleteElement({id: _id, callback: onDeleteSuccess}));
    };


    const {formatMessage} = useIntl();
    const getTableTitle = () => {
        return formatMessage({id: "UserTitle", defaultMessage: "User"});
    };

    return (
        <Grid container>
            <Grid item xs={12}>
                <BasicTable
                    columns={columns}
                    data={elements}
                    title={getTableTitle()}
                    striped
                    modalToggler={() => handleModalOpen(!open)}
                />

                <ElementModalGeneric
                    open={open}
                    setOpen={handleModalOpen}
                    element={selectedElement}
                    FormComponent={UserAdminElementForm}
                />
                {selectedDeleteElement && (
                    <AlertExampleElementDelete
                        id={selectedDeleteElement._id}
                        title={selectedDeleteElement.username || ""}
                        open={deleteAlertOpen}
                        handleClose={() => setDeleteAlertOpen(false)}
                        onDelete={(id) => handleDelete(id)}
                    />
                )}
            </Grid>
        </Grid>
    );
}